import { render, staticRenderFns } from "./FooterComponentEdunetasia.vue?vue&type=template&id=765f587c&scoped=true"
import script from "./FooterComponentEdunetasia.vue?vue&type=script&lang=ts"
export * from "./FooterComponentEdunetasia.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentEdunetasia.vue?vue&type=style&index=0&id=765f587c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765f587c",
  null
  
)

export default component.exports